import { render, staticRenderFns } from "./OfficeCard.vue?vue&type=template&id=32d100bc&"
import script from "./OfficeCard.vue?vue&type=script&lang=js&"
export * from "./OfficeCard.vue?vue&type=script&lang=js&"
import style0 from "./OfficeCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports